import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Container } from '@mui/material';
import { ConfigContext } from '../Config/ConfigContext';

/**
 * Maintenance component for displaying a maintenance message when the application is undergoing maintenance.
 *
 * @param {Object} props - The component props.
 * @param {React.ReactNode} props.children - The content to display when not in maintenance mode.
 * @returns {JSX.Element} The rendered Maintenance component.
 */
export default function Maintenance(props) {
	const { config } = useContext(ConfigContext);

	return (
		<React.Fragment>
			{config.maintenance &&
				<Container>
					This application is currently undergoing maintenance. Please try back later.
				</Container>
			}
			{!config.maintenance &&
				(props.children)
			}
		</React.Fragment>
	);
}

Maintenance.propTypes = {
	children: PropTypes.node.isRequired,
};
